import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { UserService } from './user.service';
import { MatDialog } from '@angular/material/dialog';
import { ChangePasswordComponent } from '../auth/change-password/change-password.component';

@Injectable({
  providedIn: 'root'
})
export class LoginGuard {
  constructor(private _router: Router, private userService: UserService, private route: ActivatedRoute, private dialog: MatDialog) {


  }
  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean | UrlTree {

    if (localStorage.getItem('currentUser') === "null" || localStorage.getItem('currentUser') === null || localStorage.getItem("currentPermissions") == null || localStorage.getItem("currentPermissions") == "null" || localStorage.getItem("currentModuleSubmodule") == null || localStorage.getItem("currentModuleSubmodule") == "null") {
      this._router.navigate(['/login']);
      return false;
    }
    else {
      this.userService.loggedinUser = JSON.parse(localStorage.getItem('currentUser'));
      this.userService.loggedinPermissions = JSON.parse(localStorage.getItem('currentPermissions'));
      this.userService.loggedinAllModulesSubmodules = JSON.parse(localStorage.getItem("currentModuleSubmodule"));
      this.userService.settingUpRolesAndPermissions();
      if (this.userService.loggedinUser.isFirstLogin == null || this.userService.loggedinUser.isFirstLogin == true) {
        this.dialog.closeAll();
        this.dialog.open(ChangePasswordComponent, {
          enterAnimationDuration: '400ms',
          exitAnimationDuration: '500ms',
          width: '35%',
          disableClose: true
        });
      } else {
        if (window.location.pathname.indexOf("app/clause/") >= 0) {
          if (this.userService.permissionsValue['_CLAUSES_VIEW_'])
            return true;
          else
            this._router.navigate(['app/dashboard']);
        }
        else if (window.location.pathname.indexOf("/app/contract-type") >= 0) {
          if (this.userService.permissionsValue['_CONTRACT_TYPE_VIEW_'])
            return true;
          else
            this._router.navigate(['app/dashboard']);
        }
        else if (window.location.pathname.indexOf("/app/contract-template") >= 0) {
          if (this.userService.permissionsValue['_TEMPLATES_VIEW_'])
            return true;
          else
            this._router.navigate(['app/dashboard']);
        }
        else
          return true;
      }
    }
  }

}
